import { reloadAuthorized } from './Authorized' // use localStorage to store the authority info, which might be sent from server in actual project.

// 获取权限
export function getAuthority(str) {
    const authorityString =
        typeof str === 'undefined' && localStorage ? localStorage.getItem(PROJECT_CONFIG.authorizedKey) : str // authorityString could be admin, "admin", ["admin"]

    let authority = []

    try {
        if (authorityString) {
            authority = JSON.parse(authorityString)
        }
    } catch (e) {
        console.error('catchError', e)
        authority = authorityString
    }
    if (typeof authority === 'string') {
        return [authority]
    }

    return authority
}

// 设置权限
export function setAuthority(authority) {
    const proAuthority = typeof authority === 'string' ? [authority] : authority
    localStorage.setItem(PROJECT_CONFIG.authorizedKey, JSON.stringify(proAuthority)) // auto reload

    reloadAuthorized()
}

// 清除权限
export function clearAuthority() {
    if (localStorage) {
        localStorage.removeItem(PROJECT_CONFIG.authorizedKey)
    }
}
